import {
  Checkbox,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tab,
  Tabs,
} from "@mui/material";
import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import { Button, Container, Row } from "react-bootstrap";
import {
  Tournament,
  tournamentStore,
  TournamentTab,
} from "../../../Stores/tournamentStore";
import { portalStore } from "../../../Stores/portal";
import { TournamentLog } from "./log";
import { LiveScoreBoard } from "../../../Components/Boards/liveScoreBoard";
import { ResultsAndMatches } from "./results";
import { useNavigate, useParams } from "react-router";
import RevenueView from "./revenue";

export type Segment = "Log" | "Results" | "Revenue";

const _Tournaments: React.FC = () => {
  const nav = useNavigate();
  useEffect(() => {
    console.log(tournamentStore.tournaments);
  }, [tournamentStore.tournaments]);

  return (
    <Row
      style={{
        height: portalStore.portalHeight,
        overflow: "hidden",
        padding: "",
      }}
    >
      <List
        style={{
          width: "300px",
          maxHeight: "100%",
          overflowY: "scroll",
          background: "whitesmoke",
        }}
      >
        {(tournamentStore.tournaments as { id: string; title: string }[]).map(
          (t, i) => (
            <ListItemButton
              role={"checkbox"}
              onClick={() => {
                nav("/tournaments/" + t.id);
              }}
              dense
              key={i}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={true}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": t.id }}
                />
              </ListItemIcon>
              <ListItemText id={t.id} primary={`${t.title}`} />
            </ListItemButton>
          )
        )}
      </List>
      <div style={{ width: "75%" }}>
        <TournamentFocus />
      </div>
    </Row>
  );
};

const _TournamentFocus: React.FC = () => {
  const { id } = useParams();
  const [segment, setSegment] = useState<Segment>("Log");
  const [tournament, setTournament] = useState<Tournament | null>(null);

  useEffect(() => {
    if (id) {
      const _t = tournamentStore.tournaments.find((a) => a.id === id);
      if (_t) setTournament(_t);
    }
  }, [id]);

  if (tournament === null) return <h1>Select Tournament from the left</h1>;
  return (
    <div
      style={{
        height: portalStore.portalHeight,
        textAlign: "center",
        display: "flex",
        flexFlow: "row",
        padding: "0px",
        columnGap: "50px",
      }}
    >
      <div style={{ width: "35%", display: "flex", flexFlow: "column" }}>
        <TournamentDetails tournament={tournament} />
        <Button
          onClick={() => {
            setSegment("Log");
          }}
        >
          Log / Table
        </Button>
        <Button
          onClick={() => {
            setSegment("Results");
          }}
        >
          Matches and Results
        </Button>
        <Button
          onClick={() => {
            setSegment("Revenue");
          }}
        >
          Revenue
        </Button>
      </div>
      <div style={{ width: "65%" }}>
        <SegmentSwitch segment={segment} tournament={tournament} />
      </div>
    </div>
  );
};

const SegmentSwitch: React.FC<{ segment: Segment; tournament: Tournament }> = ({
  segment,
}) => {
  const { id } = useParams();

  useEffect(() => {
    console.log("load with param ", id);
  }, [id]);

  if (id === undefined) {
    return <></>;
  }

  switch (segment) {
    case "Log":
    default:
      return <TournamentLog />;

    case "Results":
      return <ResultsAndMatches />;

    case "Revenue":
      return <RevenueView />;
  }
};

const _TournamentDetails: React.FC<{ tournament: Tournament }> = ({
  tournament,
}) => {
  if (tournament === null) return <></>;
  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        background: "rgba(78,78,78,0.2)",
        textAlign: "center",
        padding: "25px",
      }}
    >
      <label>Tournament Details</label>
      <h1 style={{ fontWeight: "bolder" }}>{`${tournament.title}`}</h1>
      <div style={{ display: "flex", flexFlow: "row" }}>
        <LiveScoreBoard tournament={tournament} />
      </div>
    </div>
  );
};

const TournamentDetails = observer(_TournamentDetails);

const TournamentFocus = observer(_TournamentFocus);

const Tournaments = observer(_Tournaments);

export { Tournaments, TournamentFocus };
